<template>
  <aside :class="['main_aside', {'expanded': $store.state.burgerExpanded || $store.state.isMobWidth}]">
    <div>
      <search-aside-widget/>
      <section class="main_nav_section nav_section">
        <ul>
          <li @click="handleClickNav"><router-link to="/" :active="$store.state.section == 'hunt'"><aside-hunt-svg/><span>Найм</span></router-link></li>
          <li @click="handleClickNav"><router-link to="/archive" :active="$store.state.section == 'archive'"><aside-archive-svg/><span>Закрытые вакансии</span></router-link></li>
          <li @click="handleClickNav">
            <router-link to="/messages" v-if="!$store.getters.getUserIsCustomer" :active="$store.state.section == 'messages'" @click="handleClickNav">
              <aside-messages-svg/><span>Сообщения</span><span v-show="$store.state.chatNewCount" v-b-tooltip.hover :title="$store.state.chatNewCount"  class="info_blue_dot"><span>{{$store.state.chatNewCount < 100 ? `+${$store.state.chatNewCount}` : ''}}</span></span>
            </router-link>
          </li>
          <li @click="handleClickNav"><router-link to="/calendar" :active="$store.state.section == 'calendar'"><aside-calendar-svg/><span>Календарь</span></router-link></li>
          <li @click="handleClickNav"><router-link to="/analytics" :active="$store.state.section == 'analytics'"><aside-analytics-svg/><span>Аналитика</span></router-link></li>
          <li @click="handleClickNav"><router-link to="/tasks" :active="$store.state.section == 'tasks'"><aside-tasks-svg/><span>Задачи</span></router-link></li>
          <li @click="handleClickNav"><router-link to="/hunt-requests/requests" :active="$store.state.section == 'hunt-requests'"><aside-archive-svg/><span>Заявки на найм</span></router-link></li>
          <li @click="handleClickNav"><router-link to="/hired" :active="$store.state.section == 'hired'"><aside-hunt-svg/><span>Нанятые</span></router-link></li>
        </ul>
      </section>
      <section :class="['fast_access_section', {'hidden': !this.$store.state.burgerExpanded}]">
        <p>Быстрый доступ:</p>
        <ul class="chrome_scrollbar">
          <li @click="handleClickNav" v-for="favorite in $store.getters.get('favorites')" v-show="favorite.item"><favorite-active-svg/> <router-link :to="favorite.item.office_link">{{favorite.item.title}}</router-link></li>
        </ul>
      </section>
      <section class="middle_nav_section nav_section">
        <ul>
          <li @click="handleClickNav"><router-link :to="settingsLink" :class="{'router-link-exact-active': $route.fullPath.startsWith('/settings')}"><aside-settings-svg/><span>Настройки</span></router-link></li>
<!--          <li><router-link to="/news"><aside-news-svg/><span>Новости</span></router-link></li>-->
<!--          <li @click="handleClickNav"><router-link to="/support/list"><aside-support-svg/><span>Техподдержка</span></router-link></li>-->
        </ul>
      </section>

      <section v-if="showSubscribeExpired && !isClosedSubscribeExpired" class="subscribe_expired_section" :style="{ 'background-image': 'url(https://hr-crm.io/assets/img/office/aside_subscribe_notification_bg.png)'}">
        <div class="top_block">
          <button class="no_btn" @click="isClosedSubscribeExpired = true">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.6349 9.97342C12.1217 10.4238 12.1217 11.2119 11.6349 11.6622C11.4103 11.8874 11.1108 12 10.8112 12C10.4743 12 10.1747 11.8874 9.95008 11.6622L6.01872 7.72166L2.04992 11.6622C1.82527 11.8874 1.52574 12 1.22621 12C0.889236 12 0.589704 11.8874 0.365055 11.6622C-0.121685 11.2119 -0.121685 10.4238 0.365055 9.97342L4.29641 5.99531L0.365055 2.05473C-0.121685 1.60438 -0.121685 0.816263 0.365055 0.365911C0.814353 -0.12197 1.60062 -0.12197 2.04992 0.365911L6.01872 4.30649L9.95008 0.365911C10.3994 -0.12197 11.1856 -0.12197 11.6349 0.365911C12.1217 0.816263 12.1217 1.60438 11.6349 2.05473L7.70359 6.03284L11.6349 9.97342Z" fill="white"/>
            </svg>
          </button>
        </div>
        <article>
          <p>Срок подписки заканчивается</p>
          <span>Срок вашей подписки скоро истекает. Для продолжения использования системы, пожалуйста, продлите подписку</span>
          <button class="no_btn" @click="handleClickNav(); $router.history.push('/settings/subscribe/pay')">Продлить подписку</button>
        </article>
        <div class="pay_info_expanded_block">
          <p><aside-pay-crow-svg/>{{subscribeInfo[0]}}</p>
          <p><aside-tests-svg/>Тестов: {{testsInfo}}</p>
        </div>

      </section>
      <section v-else :class="['pay_info_section', {'active': $store.getters.activeSubscribe}]" :style="{ 'background-image': bgPaySection}" >
        <div class="pay_info_expanded_block">
          <p><aside-pay-crow-svg/>{{subscribeInfo[0]}}</p>
          <p><aside-tests-svg/>Тестов: {{testsInfo}}</p>
        </div>
        <div class="pay_info_collapsed_block"><span v-show="testsInfo">{{testsInfo}}</span></div>
      </section>
      <section class="update_subscribe_section" v-show="!$store.getters.activeSubscribe">
        <p>Обновление уровня подписки</p>
        <small>Расширьте свое рабочее пространство и откройте дополнительные возможности</small>
        <button class="system_primary_blue_btn" @click="handleClickNav(); $router.history.push('/settings/subscribe/pay')">Приобрести подписку</button>
      </section>
    </div>
  </aside>
</template>

<script>
import AsideHuntSvg from "../components/common/svg/aside-hunt-svg.vue";
import AsideArchiveSvg from "../components/common/svg/aside-archive-svg.vue";
import AsideCalendarSvg from "../components/common/svg/aside-calendar-svg.vue";
import AsideAnalyticsSvg from "../components/common/svg/aside-analytics-svg.vue";
import AsideMessagesSvg from "../components/common/svg/aside-messages-svg.vue";
import AsideSettingsSvg from "../components/common/svg/aside-settings-svg.vue";
import AsideNewsSvg from "../components/common/svg/aside-news-svg.vue";
import AsideSupportSvg from "../components/common/svg/aside-support-svg.vue";
import AsidePayCrowSvg from "../components/common/svg/aside-pay-crow-svg.vue";
import AsideTestsSvg from "../components/common/svg/aside-tests-svg.vue";
import AsideTasksSvg from "../components/common/svg/aside-tasks-svg.vue";
import SearchAsideWidget from "../components/search-aside-widget.vue";
import {days_between} from "../utils";
import FavoriteActiveSvg from "../components/common/svg/favorite-active-svg.vue";

export default {
  name: "Aside",
  components: {
    FavoriteActiveSvg,
    SearchAsideWidget,
    AsideTasksSvg,
    AsideTestsSvg,
    AsidePayCrowSvg,
    AsideSupportSvg,
    AsideNewsSvg,
    AsideSettingsSvg, AsideMessagesSvg, AsideAnalyticsSvg, AsideCalendarSvg, AsideArchiveSvg, AsideHuntSvg},
  data() {
    return {
      isClosedSubscribeExpired: false
    }
  },
  mounted() {
    this.$store.dispatch('getFavorites')

  },
  computed: {
    settingsLink() {
      if(this.$store.state.isMobWidth) return '/settings';
      else if(this.$store.getters.getUser?.is_customer) return '/settings/profile';
      else return '/settings/profile'
    },
    bgPaySection() {
      if(this.$store.state.burgerExpanded || this.$store.state.isMobWidth) {
        if (this.$store.getters.activeSubscribe) {
          return 'url(https://hr-crm.io/assets/img/office/aside_pay_info_bg.png)';
        } else {
          return 'url(https://hr-crm.io/assets/img/office/aside_pay_info_not_active_bg.png)';
        }
      }
      return 'none'
    },
    subscribeInfo() {
      return this.$store.getters.activeSubscribe === null ?
          ['Не активна', '–', '-'] :
          [`Подписка до ${this.dateTo(this.$store.getters.activeSubscribe.end_date, true, '')}`,
            `${this.pluralize(this.$store.getters.activeSubscribe.users, [this.trans('labels.user'), this.trans('labels.user_10'), this.trans('labels.user_10')])}`,
              ``
          ]
    },
    showSubscribeExpired() {
      const days = days_between(new Date(this.$store.getters.activeSubscribe?.end_date), new Date());
      return this.$store.getters.activeSubscribe && days && days < 10 && days >= 0;
    },

    testsInfo() {
      return this.$store.state.user ? this.$store.state.user.tests_count : 0
    }
  },
  methods: {
    handleClickNav() {
      if(this.$store.state.isMobWidth) this.$emit('toggle-show')
    }
  }
}
</script>

<style>

.main_aside .hidden {visibility: hidden;}
.main_aside {max-width: 72px; height: calc(100vh - 56px); width: 72px; transition: 0.2s all ease; position: relative; z-index: 1001}
.main_aside.expanded {max-width: 312px; width: 312px;}
.main_aside .nav_section > ul > li:not(:last-child) {margin-bottom: 3px}
.main_aside .nav_section > ul > li > a > span {overflow: hidden; text-overflow: ellipsis; white-space: nowrap;}
.main_aside:not(.expanded) .nav_section > ul > li:not(:first-child) {margin-top: 4px;}
.main_aside:not(.expanded) .nav_section > ul > li > a > span {display: none;}
.main_aside:not(.expanded) .nav_section > ul > li > a {padding: 0; justify-content: center;}
.main_aside:not(.expanded) .nav_section > ul > li > a > svg {margin-right: 0;}
.main_aside > div {padding: 15px 15px 0; position: fixed; width: inherit; background: var(--System-Beige); display: flex; flex-direction: column; height: inherit}
.main_aside .nav_section > ul {list-style: none; padding: 0; margin: 0;}
.main_aside .nav_section > ul > li > a {line-height: 24px; font-size: 14px; color: var(--System-Text-grey-new); font-weight: 500; height: 40px; display: flex; align-items: center;
  padding: 8px 16px; border-radius: 4px; position: relative}
.main_aside .nav_section > ul > li > a > .info_blue_dot {width: 24px; height: 24px; display: flex; justify-content: center; align-items: center; background: var(--Button-Background);
  color: #FFFFFF; border-radius: 50%; font-size: 12px; font-weight: 700; position: absolute; right: 4px;}
.main_aside .nav_section > ul > li > a > .info_blue_dot > span {overflow: hidden; text-overflow: ellipsis; white-space: nowrap;}

.main_aside .nav_section > ul > li > a:hover {background: rgba(37, 145, 203, 0.2); color: #6C757D}
.main_aside .nav_section > ul > li > a:hover > svg > path {fill: #6C757D}
.main_aside .nav_section > ul > li > a > svg {margin-right: 10px; min-width: 20px;}
.main_aside .nav_section > ul > li > a.router-link-exact-active {background: var(--System-White); box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.05); border: 1px solid var(--System-Grey-7); color: var(--System-Text); border-radius: 8px}
.main_aside .nav_section > ul > li > a.router-link-exact-active > svg > path {fill: var(--System-Text)}
.main_aside .nav_section > ul > li > a:hover {text-decoration: none;}

.main_aside .fast_access_section {flex: 1 0; margin-top: 28px; margin-bottom: 16px;}
.main_aside .fast_access_section > p {font-size: 14px; line-height: 24px; color: #868C95; margin-bottom: 8px; margin-left: 1px;}
.main_aside .fast_access_section > ul {list-style: none; margin-bottom: 0; padding-left: 16px;  overflow-y: auto; max-height: 204px;}
.main_aside .fast_access_section > ul > li {display: flex;}
.main_aside .fast_access_section > ul > li:not(:first-child) {margin-top: 8px;}
.main_aside .fast_access_section > ul > li > a {color: var(--System-Grey-2); font-weight: 500; font-size: 14px; text-decoration: none;}
.main_aside .fast_access_section > ul > li > svg {margin-right: 6px;}

.main_aside .pay_info_section {margin: 16px -15px 0 -15px;}
.main_aside .pay_info_section:not(.active) {background-size: 100%; background-repeat: no-repeat; min-height: 58px; background-position: center}
.main_aside .pay_info_section:not(.active) > .pay_info_expanded_block, .main_aside .pay_info_section:not(.active) > .pay_info_collapsed_block {display: none !important;}
.main_aside .pay_info_section.active {height: 98px;}

.main_aside .update_subscribe_section {margin-top: 16px; text-align: center; margin-bottom: 16px;}
.main_aside .update_subscribe_section > p {margin:0; color: #000; font-size: 16px; font-weight: 500; line-height: 24px;}
.main_aside .update_subscribe_section > small {color: #000; font-weight: 400; font-size: 12px; margin: 4px 0 16px 0; display: block;}
.main_aside .update_subscribe_section > button {width: 90%; border: none;}

.main_aside .pay_info_section > .pay_info_expanded_block > p {line-height: 24px; font-size: 14px; font-weight: 500; color: #FFFFFF; margin: 0; word-break: keep-all; white-space: nowrap}
.main_aside .pay_info_section > .pay_info_expanded_block > p:not(:first-child) {margin-top: 10px;}
.main_aside .pay_info_section {padding: 24px 18px 24px 18px; display: flex; flex-direction: column;}
.main_aside .pay_info_section > .pay_info_expanded_block > p > svg {margin-right: 10px; vertical-align: top;}
.main_aside .pay_info_section > .pay_info_expanded_block > p:first-child > svg {margin-top: 3px;}
.main_aside .pay_info_section > .pay_info_collapsed_block {display: flex; align-items: center; justify-content: center; height: 100%;}
.main_aside .pay_info_section > .pay_info_collapsed_block > span {}
.main_aside:not(.expanded) .pay_info_section > .pay_info_expanded_block {display: none;}
.main_aside:not(.expanded) .pay_info_section {margin: 16px 0 0; padding: 0}
.main_aside.expanded .pay_info_section > .pay_info_expanded_block {display: block;}
.main_aside.expanded .pay_info_section > .pay_info_collapsed_block {display: none;}

.container.burger_not_expanded_white > .main_aside .subscribe_expired_section {display: none;}
.main_aside .subscribe_expired_section {margin: 16px -15px 0 -15px; background: var(--System-Red, #FF3B30); position: absolute; bottom: 0; right: 16px; opacity: .8}
.main_aside .subscribe_expired_section > .top_block {height: 72px; position: relative;}
.main_aside .subscribe_expired_section > .top_block > button {position: absolute; right: 8px; top: 4px;}
.main_aside .subscribe_expired_section > article {text-align: center; padding: 0 24px;}
.main_aside .subscribe_expired_section > article > p {margin: 0 0 8px 0; font-size: 16px; font-weight: 500; line-height: 24px; color: var(--System-Permanent-text-white);}
.main_aside .subscribe_expired_section > article > span {font-size: 12px; color: var(--System-Permanent-text-white);}
.main_aside .subscribe_expired_section > article > button {display: flex; margin-top: 16px; justify-content: center; align-items: center; font-size: 14px; font-weight: 500; height: 36px;
  color: var(--System-Permanent-text-white);
  border-radius: 8px; border: 1px solid var(--System-Permanent-text-white); width: 100%;}
.main_aside .subscribe_expired_section > article > button:hover {background: var(--System-Hover)}
.main_aside .subscribe_expired_section > .pay_info_expanded_block {margin-top: 18px; padding: 0 24px; margin-bottom: 8px;}
.main_aside .subscribe_expired_section > .pay_info_expanded_block > p {line-height: 24px; font-size: 14px; font-weight: 500; color: var(--System-Permanent-text-white); margin: 0; word-break: keep-all; white-space: nowrap}
.main_aside .subscribe_expired_section > .pay_info_expanded_block > p:not(:first-child) {margin-top: 8px;}
.main_aside .subscribe_expired_section > .pay_info_expanded_block > p > svg {margin-right: 10px; vertical-align: top;}
.main_aside .subscribe_expired_section > .pay_info_expanded_block > p:first-child > svg {margin-top: 3px;}


@media (max-width: 992px) {
  .header_main + .container > .main_aside {display: none;}
  .aside_mb_wrapper_block > .main_aside {width: 100%; height: 100%; max-width: unset;}
  .aside_mb_wrapper_block > .main_aside > div {padding: 16px 16px 0 16px; position: static; height: inherit;}
  .main_aside .pay_info_section {margin: 16px -16px 0 -16px;}
  .main_aside .fast_access_section {flex: 1 1;}
}
</style>
